export default function getItemType(
  item = {}
) {
  return item._type
}
